var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205 6.167L8.54196 10.6455V0.125H6.45798V10.6455L1.97948 6.167L0.520508 7.625L7.50001 14.6045L14.4795 7.625L13.0205 6.167Z",
    fill: "#203D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77051 16.792H13.2285V18.875H1.77051V16.792Z",
    fill: "#203D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e1dcedb545d11c5954cbb2f6fad65ac3.svg";
export { ForwardRef as ReactComponent };